import Poll from './Poll';
import PollOption from './PollOption';
import PollVote from './PollVote';
import PollGroup from './PollGroup';

export const models = {
  Poll,
  PollOption,
  PollVote,
  PollGroup,
};
